const work_units = {
  main: [
    {
      label: 'ед.',
      value: 'ед.',
    },
    {
      label: 'м3',
      value: 'м3',
    },
    {
      label: 'м2',
      value: 'м2',
    }, {
      label: 'шт.',
      value: 'шт.',
    }, {
      label: 'тн.',
      value: 'тн.',
    }, {
      label: 'п.м.',
      value: 'п.м.',
    }, {
      label: 'м',
      value: 'м',
    }, {
      label: '%',
      value: '%',
    }, {
      label: 'стык',
      value: 'стык',
    }, {
      label: 'дюйм',
      value: 'дюйм',
    }, {
      label: 'ч/ч',
      value: 'ч/ч',
    }, {
      label: 'м/ч',
      value: 'м/ч',
    },
  ],
  prof: [
    {
      label: 'ИТР',
      value: 'itr',
    },
    {
      label: 'Рабочие',
      value: 'worker',
    },
  ],
  tech: [
    {
      label: 'Механизмы',
      value: 'mechanism',
    },
    {
      label: 'Грузоподъемные',
      value: 'lifting',
    },
    {
      label: 'Грузовые',
      value: 'freight',
    },
    {
      label: 'Легковые',
      value: 'passenger_cars',
    },
    {
      label: 'Оборудование',
      value: 'equipment',
    },
    {
      label: 'Прочее',
      value: 'other',
    },
  ],
};
export default work_units;



// WEBPACK FOOTER //
// ./src/data/work_units.js